export * from './analysis.api';

// export * from './apolloService';

export * from './insights.api';

export * from './integration.api';

export * from './login.api';

export * from './projects.api';

export * from './questionnaires.api';

export * from './dealComplexity.api';

export * from './systemSettings.api';

export * from './commonService.api';

export * from './projectInfo.api';

export const BASE_URL = '/api/v1';
